import { isWeixin } from '@/utils/wechat'
import { LS_WECHAT_USER_INFO_KEY } from '@/configs/constants'
import wx from 'weixin-js-sdk'
export const initSet = pageInfo => {
    window.cw(
        'ajax',
        'jsconfig?url=' + encodeURIComponent(window.location.href),
        function(code) {
            wx.config({
                debug: false,
                appId: code.appid,
                nonceStr: code.nonceStr,
                signature: code.signature,
                timestamp: code.timestamp,
                jsApiList: [
                    'updateAppMessageShareData',
                    'updateTimelineShareData'
                ]
            })
            setInfo(pageInfo)
        }
    )
}
function updateWxShareData(shareInfo) {
    if (shareInfo && shareInfo.title && shareInfo.title !== 'undefined') {
        wx.ready(function() {
            //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
                title: shareInfo.title, // 分享标题
                desc: shareInfo.description, // 分享描述
                link: shareInfo.link || window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareInfo.image, // 分享图标
                success: function() {
                    // 设置成功
                }
            })
        })
        wx.ready(function() {
            //需在用户可能点击分享按钮前就先调用
            wx.updateTimelineShareData({
                title: shareInfo.title, // 分享标题
                desc: shareInfo.description, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareInfo.image, // 分享图标
                success: function() {
                    // 设置成功
                }
            })
        })
    }
}
export const setInfo = pageInfo => {
    if (!pageInfo.title || pageInfo.title === 'undefined') return
    // 分享信息
    updateWxShareData(pageInfo.shareInfo)
    window.cw(
        'info',
        function(info) {
            localStorage.setItem(LS_WECHAT_USER_INFO_KEY, JSON.stringify(info))
            window.ca('set', 'appid', window.cw('get', 'appid'))
            window.ca('set', 'openid', info.openid)
            window.ca('set', 'nickname', info.nickname)
            window.ca('send', 'pageview', { title: pageInfo.title })
            let page = {
                title: pageInfo.title || window.document.title,
                path: window.location.href,
                uaId: window.ca('get', 'tid')
            }
            if (pageInfo.productBu) {
                page.productBu = pageInfo.productBu
            }
            window.cw('action', 'pageview', page)
        },
        function() {
            if (isWeixin()) {
                window.cw('login')
            } else {
                window.ca('send', 'pageview', { title: pageInfo.title })
            }
        }
    )
}
